export const ACCESS_MANAGEMENT = {
    TOOL_ACCESS: 'res.access.iam',
    USER_READ: 'res.iam.user.read',
    USER_CREATE: 'res.iam.user.create',
    USER_UPDATE: 'res.iam.user.update',
    USER_DELETE: 'res.iam.user.delete',
    USER_EXPORT: 'res.iam.user.export',
    AUDIT_READ: 'res.iam.audit.read',
};

export const VENDOR_ADMIN = {
    APPROVE_REQUESTS: 'res.eva.request.approve',
    DECLINE_REQUESTS: 'res.eva.request.deny',
    READ_REQUESTS: 'res.eva.request.read',
};

export const PB_ADMIN = {
    USER_READ: 'res.iam.user.read',
    UPDATE_ROLE: 'res.eva.user.update',
    VENDOR_READ: 'res.eva.vendor.read',
    CREATE_VENDOR: 'res.eva.vendor.create',
    DELETE_VENDOR: 'res.eva.vendor.delete',
    UPDATE_VENDOR: 'res.eva.vendor.update',
    DELETE_USER: 'res.eva.user.delete',
    UPDATE_USER: 'res.eva.user.vendors.update',
    DELETE_RULE: 'res.eva.rule.delete',
    CREATE_RULE: 'res.eva.rule.create',
    SEND_LOGIN_LINK: 'res.iam.user.login-link.create',
};
